import request from "lib/request"
import config from "config/app"
import lib from 'lib/commons'
import lang from "lng/index"
const lng = lang[config.lng]

export const CURRENT_USER_REQUEST         = 'CURRENT_USER_REQUEST'
export const CURRENT_USER_REQUEST_ERROR   = 'CURRENT_USER_REQUEST_ERROR'
export const CURRENT_USER_REQUEST_SUCCESS = 'CURRENT_USER_REQUEST_SUCCESS'
export const CURRENT_USER_FETCHING        = 'CURRENT_USER_FETCHING'

export const SPIN         = 'SPIN'
export const SPIN_ERROR   = 'SPIN_ERROR'
export const SPIN_SUCCESS = 'SPIN_SUCCESS'
export const IS_SPINNING  = 'IS_SPINNING'

export const SHARE_ERROR = 'SHARE_ERROR'
export const SHARE_SUCCESS = 'SHARE_SUCCESS'
export const IS_SHARING = 'IS_SHARING'

export const CHECK_MATCH_ERROR = 'CHECK_MATCH_ERROR'
export const CHECK_MATCH_SUCCESS = 'CHECK_MATCH_SUCCESS'
export const IS_CHECKING_MATCH = 'IS_CHECKING_MATCH'

export const GET_HISTORY_ERROR = 'GET_HISTORY_ERROR'
export const GET_HISTORY_SUCCESS = 'GET_HISTORY_SUCCESS'
export const IS_GETTING_HISTORY = 'IS_GETTING_HISTORY'

export const REGISTER_ERROR = 'REGISTER_ERROR'
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS'
export const IS_REGISTERING = 'IS_REGISTERING'

export const isCurrentUserFetching = () => {
  return {
    type: CURRENT_USER_FETCHING
  }
}

export const getCurrentUser = () => {
  return (dispatch, getState) => {
    dispatch(isCurrentUserFetching());
    request('api/user/get').then(function(response) {
      if(response.status == 'successful') {
        dispatch(getCurrentUserSuccess(response));
      } else {
        if(response.error_code == 'no_account') {
          lib.showDownlad()
        }
        dispatch(getCurrentUserError(response))
      }
    })
  }
}

export const getCurrentUserSuccess = (response) => {
  return {
    type: CURRENT_USER_REQUEST_SUCCESS,
    payload: response.payload
  }
}

export const getCurrentUserError = (response) => {
  return {
    type: CURRENT_USER_REQUEST_ERROR,
    payload: response.payload
  }
}

//Share
export const isSharing = (response) => {
  return {
    type: IS_SHARING,
  }
}
export const share = (shareCustom = null) => {
  return (dispatch, getState) => {
    dispatch(isSharing())
    request('api/user/share', 'POST', {
      body: JSON.stringify({})
    }).then(function (response) {
      if (response.status == 'successful') {
        if (shareCustom) {
          shareCustom()
        } else {
          lib.showMessage('<p class="text-center">Chia sẻ thành công!</p>')
        }
        dispatch(shareSuccess(response))
      } else {
        lib.showError(response.error_code)
        dispatch(shareError(response))
      }
    })
  }
}
export const shareSuccess = (response) => {
  return {
    type: SHARE_SUCCESS,
    payload: response.payload
  }
}
export const shareError = (response) => {
  return {
    type: SHARE_ERROR,
    payload: response.payload
  }
}

//CHECk MATCH
export const isCheckingMatch = (response) => {
  return {
    type: IS_CHECKING_MATCH,
  }
}
export const checkMatch = () => {
  return (dispatch, getState) => {
    dispatch(isCheckingMatch())
    request('api/user/update-daily', 'POST', {
      body: JSON.stringify({})
    }).then(function (response) {
      if (response.status == 'successful') {
        lib.showMessage(`Bạn đã cập nhật nhiệm vụ thành công`).then(res => {
          dispatch(checkMatchSuccess(response))
        })
      } else {
        lib.showError(response.error_code)
        dispatch(checkMatchError(response))
      }
    })
  }
}
export const checkMatchSuccess = (response) => {
  return {
    type: CHECK_MATCH_SUCCESS,
    payload: response.payload
  }
}
export const checkMatchError = (response) => {
  return {
    type: CHECK_MATCH_ERROR,
    payload: response
  }
}

//Spin
export const isSpinning = (response) => {
  return {
    type: IS_SPINNING,
  }
}
export const spin = (side, setBall) => {
  return (dispatch, getState) => {
    dispatch(isSpinning());
    request('api/user/spin', 'POST', {
      body: JSON.stringify({})
    }).then(function(response) {
      if(response.status == 'successful') {
        let result = response.payload.score ? 'win' : 'lose'

        setBall({ side: side == 'up' ? 'center' : side, result: result })
        setTimeout(() => {
          if(!response.payload.score) {
            lib.showMessage(`Bạn đã nhận được:<br><div class="item-result"><img src="${response?.payload?.reward[0]?.image}" alt="" class="item-result__img" /></div><p>${response?.payload?.reward[0]?.product_name}</p>`, null, 'Rất tiếc bạn sút không vào').then(res => {
              dispatch(spinSuccess(response))
            })
          } else {
            lib.showMessage(`Bạn đã nhận được:<br><div class="item-result"><img src="${response?.payload?.reward[0]?.image}" alt="" class="item-result__img" /></div><p>${response?.payload?.reward[0]?.product_name}</p>`, null, 'Chúc mừng bạn đã sút vào').then(res => {
              dispatch(spinSuccess(response))
            })
          }
        }, 1800)
      } else {
        lib.showError(response.error_code)
        dispatch(spinError(response))
      }
    })
  }
}
export const spinSuccess = (response) => {
  return {
    type: SPIN_SUCCESS,
    payload: response.payload
  }
}
export const spinError = (response) => {
  return {
    type: SPIN_ERROR,
    payload: response.payload
  }
}
//get history
export const isGettingHistory = () => {
  return {
    type: IS_GETTING_HISTORY
  }
}

export const getHistory = () => {
  return (dispatch, getState) => {
    dispatch(isGettingHistory());
    request('api/user/history').then(function(response) {
      if(response.status == 'successful') {
        dispatch(getHistorySuccess(response))
      } else {
        dispatch(getHistoryError(response))
      }
    })
  }
}

export const getHistorySuccess = (response) => {
  return {
    type: GET_HISTORY_SUCCESS,
    payload: response.payload
  }
}

export const getHistoryError = (response) => {
  return {
    type: GET_HISTORY_ERROR,
    payload: response.payload
  }
}

// Register
export const isRegistering = (response) => {
  return {
    type: IS_REGISTERING,
  }
}
export const register = (data, closeModal) => {
  return (dispatch, getState) => {
    dispatch(isRegistering())
    request('api/user/register', 'POST', {
      body: JSON.stringify({
        address: data.address,
        name: data.name,
        phone_number: data.phone_number
      })
    }).then(function (response) {
      if (response.status == 'successful') {
        lib.showMessage('Bạn đã đăng ký thành công<br>Chúng tôi sẽ sớm liên hệ với bạn!', null, 'Chúc mừng!').then(res => {
          closeModal()
          dispatch(registerSuccess(response))
        })
      } else {
        lib.showError(response.error_code)
        dispatch(registerError(response))
      }
    })
  }
}
export const registerSuccess = (response) => {
  return {
    type: REGISTER_SUCCESS,
    payload: response.payload
  }
}
export const registerError = (response) => {
  return {
    type: REGISTER_ERROR,
    payload: response
  }
}
